module.exports = __webpack_public_path__ + "assets/img/NPC041.aa3f5f7c.png";